module.exports = __webpack_public_path__ + "img/symbol_9.2ce73281.png";